import React, { useEffect, useState } from 'react'
import { ProgressBar } from 'react-loader-spinner';
import Header from 'units/dashboard/components/Header';
import { SidebarProvider } from 'units/dashboard/context/SidebarProvider';
import Footer from 'units/dashboard/components/Footer';
import AdminSidebar from '../components/AdminSidebar';
import DiscountCodeForm from './components/DiscountCodeForm'
import DiscountCodeTable from './components/DiscountCodeTable'
import { createOfferCode, deleteOfferCode, offerCodeList } from './services/OfferCodeServices'
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
export default function OfferCodes() {
    const [loading, setLoading] = useState(false);
    const [discounts, setDiscounts] = useState([]);
    const [offerCode, setOfferCode] = useState([])
    const accessToken = useSelector((state) => state.auth.accessToken);
    const handleAddDiscount = async (data) => {
        setDiscounts((prev) => [...prev, data]);
        try {
            const res = await createOfferCode({ accessToken, percent: data?.amount, expireDate: data?.expireAt })
            if (res?.ok) {
                setOfferCode(res?.data)
                toast.success(`کد تخفیف ${res?.data?.code}  با موفقیت ثبت شد.`);
            }

        } catch (error) {
            toast.error("خطا در ثبت کد تخفیف.");
            console.log(error)
        }

    };
    const offerList = async () => {
        setLoading(true)
        try {
            const res = await offerCodeList(accessToken)
            if (res?.ok) {
                setLoading(false)
                setDiscounts(res?.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }
    const handleDeleteDiscount = async (code, indexToRemove) => {
        setDiscounts((prev) => prev.filter((_, i) => i !== indexToRemove));

        try {
            const res = await deleteOfferCode({ accessToken, code })
            if (res?.ok) {
                toast.success(`کد تخفیف ${code}  با موفقیت حذف شد.`);
                offerList()
            }
        } catch (error) {

        }
    };
    useEffect(() => {
        offerList()
    }, [offerCode])
    return (
        <>
            <SidebarProvider>
                <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
                    <Header />
                </nav>

                <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
                    <AdminSidebar />
                </div>
            </SidebarProvider>

            {loading ? (
                <div className="flex justify-center items-center h-screen">
                    <ProgressBar
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="progress-bar-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>
            ) : (
                <div className="flex flex-col min-h-screen mt-4">
                    <div className="main-content flex-grow pt-16 pb-12">
                        <div className="container-fluid px-[0.625rem] mt-10">
                            <div className="grid grid-cols-1 mb-2">
                                <div className="flex items-center justify-between">
                                    <h4 className="mb-sm-0 text-xl font-semibold grow text-gray-800 ">
                                        تنظیمات کد تخفیف
                                    </h4>
                                    <nav className="flex" aria-label="Breadcrumb"></nav>
                                </div>
                            </div>
                            <h1 className="text-md mr-2">

                                در این بخش می‌توانید کدهای تخفیف جدید ایجاد کرده و لیست کدهای موجود را مشاهده و مدیریت کنید.
                            </h1>
                        </div>
                        <div className="mt-10 flex items-center justify-center p-2 col-span-12 xl:col-span-9 my-10">
                            <div className="w-full max-w-5xl  rtl ">
                                <DiscountCodeForm onSubmit={handleAddDiscount} />
                                <DiscountCodeTable discounts={discounts} handleDeleteDiscount={handleDeleteDiscount} />

                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            )}
        </>
    )
}
